export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-20 sm:pt-28 pb-24" data-testid="page-privacy">
      <div className="eyebrow text-[var(--pine)] mb-5">Legal</div>
      <h1 className="font-display text-5xl sm:text-7xl leading-[0.95] mb-10">Privacy policy</h1>
      <p className="text-[var(--ink-soft)] text-sm mb-12">Last updated: January 2026</p>

      <div className="space-y-10 text-[var(--ink)] leading-relaxed">
        <Section title="In short">
          We're a small tour booking platform in Riga. We collect only what we need to reply to your inquiry and run the site. We don't sell your data. Ever.
        </Section>

        <Section title="Who we are">
          <p>This site is operated by <b>Riga Party Weekend</b>, based in Riga, Latvia. Contact: <a href="mailto:rigapartyweekend@rigapartyweekend.eu" className="underline underline-offset-4">rigapartyweekend@rigapartyweekend.eu</a>.</p>
          <p className="mt-3">For data-protection purposes, we are the "controller" of the personal data you share with us.</p>
        </Section>

        <Section title="What we collect">
          <ul className="list-disc pl-5 space-y-2">
            <li><b>Inquiry data</b> — name, email, preferred date, group size and message — submitted by you via our contact form.</li>
            <li><b>Technical data</b> — IP address, browser type and pages visited, stored only in standard server access logs.</li>
            <li><b>Cookies</b> — see "Cookies" below.</li>
          </ul>
        </Section>

        <Section title="How we use it">
          <ul className="list-disc pl-5 space-y-2">
            <li>To reply to your inquiry, send you a quote, and arrange your tour.</li>
            <li>To share necessary details (e.g. group size, date) with the tour operator running your booking.</li>
            <li>To keep the website secure and working.</li>
            <li>To improve the site and tours based on aggregate usage.</li>
          </ul>
          <p className="mt-3">We do <b>not</b> use your data for unsolicited marketing, and we do not sell it to any third party.</p>
        </Section>

        <Section title="Cookies">
          <p>We use two categories of cookies:</p>
          <ul className="list-disc pl-5 space-y-2 mt-3">
            <li><b>Essential cookies</b> — needed for the site to function (e.g. remembering your cookie consent choice). These can't be turned off.</li>
            <li><b>Analytics & marketing cookies</b> — only set if you click "Accept all" on the cookie banner. They help us understand how the site is used and run any advertising.</li>
          </ul>
          <p className="mt-3">You can change your choice at any time by clearing your browser's site data for our domain.</p>
        </Section>

        <Section title="Who we share data with">
          <ul className="list-disc pl-5 space-y-2">
            <li><b>Tour operators</b> — only the details needed to fulfil your booking.</li>
            <li><b>Email delivery</b> — Resend (resend.com), which sends inquiry notifications to us.</li>
            <li><b>Hosting</b> — our cloud hosting provider, which runs the website.</li>
          </ul>
          <p className="mt-3">All of these providers are based in or comply with the EU's GDPR.</p>
        </Section>

        <Section title="How long we keep it">
          <p>Inquiry data is kept for up to 24 months after your last contact, then deleted. Server logs are rotated every 30 days. You can ask us to delete your data earlier — see "Your rights".</p>
        </Section>

        <Section title="Your rights">
          <p>Under EU GDPR you have the right to:</p>
          <ul className="list-disc pl-5 space-y-2 mt-3">
            <li>Access the personal data we hold about you.</li>
            <li>Correct it if it's wrong.</li>
            <li>Ask us to delete it.</li>
            <li>Object to or restrict processing.</li>
            <li>Receive your data in a portable format.</li>
            <li>Lodge a complaint with the Latvian Data Protection Inspectorate (<a href="https://www.dvi.gov.lv" className="underline underline-offset-4" target="_blank" rel="noreferrer">dvi.gov.lv</a>).</li>
          </ul>
          <p className="mt-3">To exercise any of these rights, just email <a href="mailto:rigapartyweekend@rigapartyweekend.eu" className="underline underline-offset-4">rigapartyweekend@rigapartyweekend.eu</a>. We respond within 30 days.</p>
        </Section>

        <Section title="Changes">
          <p>If we update this policy, we'll change the "last updated" date at the top. Material changes will be highlighted on the home page.</p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl sm:text-3xl mb-4">{title}</h2>
      <div className="text-[var(--ink)] space-y-3">{typeof children === "string" ? <p>{children}</p> : children}</div>
    </div>
  );
}
